import React, { useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { api } from "@/redux/api";
import { useAuthEditable } from "@/hooks/use-auth";
import { buildFacilityPath, getFacilityContext } from "@/utils/route-context";
import ContractDetail from "@/containers/contract/ContractDetail";

export default function FacilityContractDetailPage() {
  const { id } = useParams();
  const location = useLocation();
  const facilityContext = useSelector((state) => getFacilityContext(state));
  const canAddNote = useAuthEditable("contract");
  const baseListPath = buildFacilityPath("contract-request", facilityContext) || "/switch-view";
  const listPath = `${baseListPath}${location.search || ""}`;

  const loadRequest = useCallback(
    (requestId) => api.getContract(requestId),
    []
  );
  const addNote = useCallback(
    (requestId, content) => api.addContractNote(requestId, content),
    []
  );
  const getWorkorderPath = useCallback(
    (record) =>
      buildFacilityPath(`workorder-detail/${record.workorder_id}`, facilityContext) || "/switch-view",
    [facilityContext]
  );

  return (
    <ContractDetail
      role="facility"
      requestId={id}
      listPath={listPath}
      loadRequest={loadRequest}
      addNote={addNote}
      canAddNote={canAddNote}
      closeContract={api.closeContract}
      getWorkorderPath={getWorkorderPath}
    />
  );
}
